<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">
  <ng-lottie 
    *ngIf="isChristmasEvent"
    class="christmas-baubles"
    width="300px"
    [options]="christmasBaublesConfigLottie"
  ></ng-lottie>

  <div [formGroup]="form" class="mx-auto flex-1 flex-col place-items-center w-80 form-wrapper">
    <div class="logo-tekom mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
      <ng-lottie
        *ngIf="isChristmasEvent"
        class="logo-tekom__lottie-hat"
        width="100px"
        [options]="chrismatHatConfigLottie"
      ></ng-lottie>
    </div>

    <div class="text-lg font-semibold text-center mb-10">{{ 'login.header' | translate }}</div>

    <div *ngIf="showGeneralError" id="general-error" class="flex items-center tk-bg-error h-10 rounded-lg">
      <span class="i-red-exclamation ml-2"></span>
      <span class="tk-c-red text-xs ml-2 opacity-100">{{ 'login.error-login-data-incorrect' | translate }}</span>
    </div>

    <mat-form-field class="mt-2 mb-2" hideRequiredMarker>
      <mat-label>{{ 'fields-names.email' | translate }}</mat-label>
      <input matInput formControlName="email" maxlength="50">
      <mat-error id="email-error-required" *ngIf="emailCtrl.hasError('required')">
        {{ 'errors.field-is-required' | translate}}
      </mat-error>
      <mat-error id="email-error-format" *ngIf="emailCtrl.hasError('email')">
        {{ 'errors.email-format-incorrect' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mb-1" hideRequiredMarker>
      <mat-label>{{ 'fields-names.password' | translate }}</mat-label>
      <input matInput [type]="inputType" formControlName="password" maxlength="50" class="tk-password-spacing">

      <span matSuffix *ngIf="!isRawPasswordVisible && isVisibleShowPasswordButton"
            class="tk-c-blue text-xs tracking-widest" (click)="onShowPasswords()">
        {{ 'labels.show' | translate | uppercase }}
      </span>

      <span matSuffix *ngIf="isRawPasswordVisible && isVisibleShowPasswordButton"
            class="tk-c-blue text-xs tracking-widest" (click)="onHidePasswords()">
        {{ 'labels.hide' | translate | uppercase }}
      </span>
      <mat-error id="password-error-required" *ngIf="passwordCtrl.hasError('required')">
        {{ 'errors.field-is-required' | translate}}
      </mat-error>

    </mat-form-field>

    <div class="mb-4 flex justify-between content-center text-xs" style="width: 100%;">
      <mat-slide-toggle formControlName="stayLoggedIn" class="">
        {{ 'login.stay-loggedin' | translate}}
      </mat-slide-toggle>

      <div class="mt-0.5">
        <a id="navigate-to-reset-password" class="tk-c-blue mt-1 cursor-pointer" (click)="onNavigateToResetPassword()">
          {{ 'login.forgotten-password' | translate}}
        </a>
      </div>
    </div>

    <app-button 
      [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine" innerTextClasses="my-1.5"
      spinnerClasses="my-3" label="{{'login.login-button' | translate}}" (click)="onLogin()" style="display: block; width: 100%;"
    ></app-button>

    <div class="text-center mt-4 text-xs">{{ 'login.or-create-account-part1' | translate}}
      <a id="navigate-to-create-account" class="tk-c-blue cursor-pointer ml-0.5" (click)="onNavigateToCreateAccount()">
        {{ 'login.or-create-account-part2' | translate}}
      </a>
    </div>

  </div>

  <am-login-footer class="w-full align self-end"></am-login-footer>
</div>
